import * as React from "react";
import type { SVGProps } from "react";
const SvgExchangeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="exchange_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M656.213 661.76h193.28A42.667 42.667 0 0 1 890.88 704v192a42.667 42.667 0 0 1-85.333 0v-75.52A426.667 426.667 0 0 1 85.333 512a42.667 42.667 0 1 1 85.334 0 341.333 341.333 0 0 0 587.946 235.093h-102.4a42.667 42.667 0 0 1 0-85.333zm-437.76-458.24A426.667 426.667 0 0 1 512 85.333 426.667 426.667 0 0 1 938.667 512a42.667 42.667 0 0 1-85.334 0 341.333 341.333 0 0 0-587.946-234.667h102.4a42.667 42.667 0 0 1 0 85.334h-192A42.667 42.667 0 0 1 133.12 320V128a42.667 42.667 0 0 1 85.333 0v75.52zM469.333 512a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0zM512 384a128 128 0 1 0 0 256 128 128 0 0 0 0-256z"
    />
  </svg>
);
export default SvgExchangeIcon;
